import React from "react";
import {Redirect, Route} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {subState} from "../../services/requestService";

function UserRoute({children, ...other}) {
    const sub = useRecoilValue(subState);
    return (
        <Route
            {...other}
            render={({location}) =>
                sub === "anonymous" || sub === "readonly" ? (
                    <Redirect to={{pathname: "/", state: {from: location}}}/>) : (children)
            }
        />
    );
}

export default UserRoute;